module.exports = {
    Change_Role_Info_Event : "Change_Role_Info_Event"
    ,Change_Role_Success : "Change_Role_Success"
};
